import React from 'react';
import { Link } from 'gatsby';
import {connectToStore} from './Provider';

const NewReleaseCountdown = ({
	title,
	countdowns,
	openNewReleaseModal,
	openQuickAddProduct,
}) => (
	<div className="grid-container contained mt12 mb12">
		<h2 className="domaine--large mb4 mb6--md">
			{title}
		</h2>
		{countdowns.map(product => (
			<div
				key={product._key}
				className="mb6 mb8--md">
				<div className="mb3 mb4--md">
					<picture className="full-width">
						<source
							srcSet={`${product.image}?w=2000&auto=format`}
							media="(min-width: 1400px)"
						/>
						<source
							srcSet={`${product.image}?w=1600&auto=format`}
							media="(min-width: 600px)"
						/>
						<img
							className="full-width"
							alt={product.title}
							src={`${product.mobileImage}?w=800&auto=format`}
						/>
					</picture>
				</div>
				<div className="row">
					<div className="col c4--xl mb2 mb0--xl">
						<h3 className="sans--small uppercase fw--600 mb1">
							{product.brand.title}
						</h3>
						<p className="domaine--medium">
							{product.title}
						</p>
					</div>
					<div className="col c5 c6--md c2--xl">
						<h3 className="sans--small uppercase fw--600 mb1">
							Price
						</h3>
						<p className="domaine--medium show--xl">
							{product.price}
						</p>
						<p className="domaine--small hide--xl">
							{product.price}
						</p>
					</div>
					<div className="col c5 c6--md c2--xl mb3 mb0--xl">
						<h3 className="sans--small uppercase fw--600 mb1">
							Release Date
						</h3>
						<p className="domaine--medium show--xl">
							{product.releaseDate}
						</p>
						<p className="domaine--small hide--xl">
							{product.releaseDate}
						</p>
					</div>
					<div className="col c4--xl">
						<div className="row gutter--mobile align--right">
							<div className="col c6--md">
								{product.enableQuickShop && product.product ? (
									<button
										title="Quick Shop"
										name="notify"
										onClick={() => openQuickAddProduct(product.product)}
										className="button--primary-black full-width">
										Quick Shop
									</button>
								) : (
									<button
										title="Notify Me"
										name="notify"
										onClick={() => openNewReleaseModal(product.brand)}
										className="button--primary-black full-width">
										Notify Me
									</button>
								)}
							</div>
							{product.product && (
								<div className="col c6--md mt2 mt0--md">
									<Link
										to={`/products/${product.product.slug}`}
										title={product.product.title}
										className="button--secondary full-width">
										Details
									</Link>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		))}
	</div>
);

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openNewReleaseModal,
	openQuickAddProduct,
}) => ({
	openNewReleaseModal,
	openQuickAddProduct,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(NewReleaseCountdown);